var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStellar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 12.7743V14.5021L10 24.6934V22.9647L10.7269 22.594C10.9974 22.4562 11.2211 22.2414 11.3699 21.9767C11.5186 21.712 11.5858 21.4092 11.5629 21.1065C11.5465 20.8927 11.5383 20.678 11.5383 20.4625C11.5382 18.9023 11.9694 17.3724 12.7844 16.0419C13.5993 14.7114 14.7663 13.6321 16.1563 12.9234C17.5463 12.2146 19.1052 11.904 20.6607 12.0258C22.2162 12.1477 23.7077 12.6972 24.9704 13.6137L23.3864 14.4209C22.3327 13.8324 21.1435 13.5294 19.9367 13.5419C18.7298 13.5544 17.5472 13.882 16.5059 14.4922C15.4647 15.1024 14.6009 15.9741 14.0001 17.0208C13.3993 18.0676 13.0825 19.2531 13.0809 20.46C13.081 20.7625 13.1008 21.0646 13.1401 21.3646L30 12.7743Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2122 24.2704L30 16.2318V17.9546L29.2723 18.3252C29.002 18.4632 28.7785 18.6781 28.6299 18.9428C28.4813 19.2074 28.4143 19.5101 28.4371 19.8127C28.4532 20.0277 28.4617 20.2451 28.4617 20.4626C28.4612 22.0226 28.0294 23.5522 27.2141 24.8822C26.3988 26.2122 25.2316 27.2909 23.8416 27.9992C22.4516 28.7075 20.8929 29.0177 19.3377 28.8956C17.7824 28.7735 16.2912 28.2238 15.0288 27.3072L16.5231 26.5457L16.6077 26.5009C17.6616 27.0918 18.8518 27.3968 20.06 27.3856C21.2683 27.3744 22.4526 27.0473 23.4954 26.4369C24.5381 25.8266 25.4031 24.954 26.0045 23.906C26.6058 22.858 26.9226 21.6709 26.9233 20.4626C26.9232 20.1582 26.9035 19.854 26.8641 19.5521L10 28.145V26.4179L14.2122 24.2704Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStellar);
export default __webpack_public_path__ + "static/media/stellar.ba6e9a8ae4f8e7f9de7affd4dd90f7f9.svg";
export { ForwardRef as ReactComponent };